import AtriumApi from "api";

const dashboardService = {
  getSummary: () => AtriumApi.get("/v2/dashboard-v2/summary"),
  getPeopleGrowth: () => AtriumApi.get("/v2/dashboard-v2/people-growth"),
  getResponses: (tab, page = 1, per = 10) =>
    AtriumApi.get(`/v2/dashboard-v2/responses?tab=${tab}&page=${page}&per=${per}`),
  getHealthScore: () => AtriumApi.get("/v2/dashboard-v2/health-score"),
  getUpcomingServices: () => AtriumApi.get("/v2/dashboard-v2/upcoming-services"),
  getLinkAnalytics: () => AtriumApi.get("/v2/dashboard-v2/link-analytics"),
};

export default dashboardService;
